import type { FGuidesHomeTemplateProps } from '@/components/templates/FGuidesHomeTemplate.vue';

export function mapApiDataToGuidesHome(
  guidesHomeRawData: StrapiResponseData<GuideContentType>[] | undefined
): FGuidesHomeTemplateProps {
  return {
    cards: (guidesHomeRawData ?? []).map(card => ({
      title: card.attributes.title ?? '',
      excerpt: card.attributes.excerpt ?? '',
      buttonLocation: `/resources/guides/${card.attributes.slug}`,
      buttonText: '',
      audience: card.attributes.audience?.data?.attributes.name ?? '',
      topics: (card.attributes.topics?.data || []).map(
        topic => topic?.attributes.name
      ),
    })),
  };
}
